import React from 'react';
import { Toaster } from 'sonner';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSlider from '../components/HeroSlider';
import CategoryGrid from '../components/CategoryGrid';
import StoreLogos from '../components/StoreLogos';
import DealsSection from '../components/DealsSection';

const HomePage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Toaster 
        position="top-right" 
        richColors 
        closeButton
        toastOptions={{
          style: {
            background: 'white',
          },
        }}
      />
      <Header />
      
      <main className="flex-1">
        {/* Hero Slider */}
        <HeroSlider />
        
        {/* Category Grid */}
        <CategoryGrid />
        
        {/* Store Logos */}
        <StoreLogos />
        
        {/* Top Deals Section */}
        <DealsSection />
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
